import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard, BorrowerObstructGuard } from "../../../../auth.guard";
import { FinzyFlexGuard } from "../../../../guards/finzy-flex.guard";
import { ProductResolver } from "../../../../resolvers/product.resolver";
import { UserAttributeComponent } from "../user-attribute/user-attribute.component";
import { UserAttributeResolver } from "../user-attribute/user-attribute.resolver";
import { FlexDashboardComponent } from "./flex-dashboard/flex-dashboard.component";
import { LenderAccountInfoResolver } from "../../../../resolvers/lender-account-info.resolver";
import { FlexHomeComponent } from "./flex-home.component";
import { UserAttributeDeactivationGuard } from "../user-attribute/user-attribute-deactivation-guard";
import { FlexInterestCertificateComponent } from "./flex-interest-certificate/flex-interest-certificate.component";
import { InitiateWithdrawalPopupComponent } from "../initiate-withdrawal-popup/initiate-withdrawal-popup.component";

const routes: Routes = [
    {
        path: '',
        component: FlexHomeComponent,
        canActivate: [AuthGuard, BorrowerObstructGuard, FinzyFlexGuard],
        children: [
            {
                path: '',
                redirectTo: 'dashboard'
            },
            {
                path: 'dashboard',
                component: FlexDashboardComponent,
            },
            {
                path:'interestCertificate',
                component:FlexInterestCertificateComponent
            },
            
            {
                path: 'loans',
                loadChildren: () => import('./flex-loans/flex-loans.module').then(m => m.FlexLoansModule),
            },
            {
                path: 'reports',
                loadChildren: () => import('./flex-report/flex-report.module').then(m => m.FlexReportModule),
            },
            {
                path: 'preferences',
                component: UserAttributeComponent,
                resolve: {
                    userAttributes: UserAttributeResolver,
                    product: ProductResolver,
                },
                canDeactivate: [UserAttributeDeactivationGuard]
            },
            {
                path: 'portfolio',
                loadChildren: () => import('./portfolio-creation/portfolio-creation.module').then(m => m.PortfolioCreationModule),
            },
            {
                path:"initiate-withdrawal", 
                component: InitiateWithdrawalPopupComponent,
                resolve: {
                    lenderAccountInfo: LenderAccountInfoResolver
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FlexHomeRoutingModule { }